<template>
  <div
    v-if="!profile && !disableLoginLink && !canGuestComment"
    class="gmf-comment-form-login-invite gmf-context"
  >
    <a
      v-if="loginUrl"
      class="gmf-login-link"
      :href="loginUrl"
      >{{ t('log_in_to_write_a.' + commentType) }}</a
    >
    <span v-else>{{ t('log_in_to_write_a.' + commentType) }}</span>
  </div>
  <div
    v-else-if="(profile && canComment) || canGuestComment"
    class="gmf-comment-form gmf-context"
  >
    <div v-if="profile && avatarsEnabled" class="gmf-comment-form-cta-left">
      <Avatar :customer="profile" disableOnlineIndicator disablePopup animated />
    </div>
    <div class="gmf-comment-form-cta-right">
      <button class="gmf-btn gmf-btn-primary" @click="openModal">
        {{ textCallToAction }}
      </button>
    </div>

  </div>
</template>

<style>
.gmf-bubbly-usp-image {
  background-image: url(https://cdn.gamifiera.com/static/placeholders/all-small-things.png);
  max-width: 600px;
  height: 329px;
  margin-top: 25px;
  display: block;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.gmf-comment-form {
  display: flex;
  color: var(--gmf-col-black);
  gap: var(--gmf-p-4);
  max-width: 100%;
}

.gmf-comment-form .gmf-avatar {
  background-size: 100%;
  background-position: center;
  width: 100%;
}
.gmf-comment-form .gmf-avatar::after {
  width: 100%;
  padding-bottom: 100%;
  content: "";
  display: block;
}

.gmf-comment-form-cta-left {
  width: 80px;
  flex-shrink: 0;
}
.gmf-comment-form-cta-right {
  display: flex;
  align-items: center;
}
.gmf-comment-form-cta-right .gmf-btn {
  padding-left: 48px;
  padding-right: 48px;
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';
import md from '@/utils/md';
import Avatar from '@/components/Avatar';

const t = state.t.prefix('comments');


import openCommentFormV2 from '@/components/CommentFormV2';
import { getLocalizedString } from '@/utils/getLocalizedString';

export default {
  props: ['commentType', 'targetId'],
  components: {
    Avatar,
  },
  data() {
    return {
      state,
      myComments: [],
    };
  },
  mounted () {
    this.loadProductInfo();
  },
  computed: {
    avatarsEnabled() {
      return this.state.merchantConfig?.avatars?.enabled !== 'disabled';
    },
    hasCommented() {
      for (const c of this.myComments) {
        if (c.commentType.name === this.commentType && c.parent === null) {
          return true;
        }
      }
      return false;
    },
    canGuestComment() {
      return this.merchantCommentTypeConfig.allowGuests === true;
    },
    canComment() {
      if (this.merchantCommentTypeConfig.canPostMultiple) {
        return true;
      }
      return !this.hasCommented;
    },
    disableLoginLink() {
      return (
        this.state.merchantConfig && this.state.merchantConfig.disableLoginLink
      );
    },
    merchantCommentConfig() {
      return (
        (this.state.merchantConfig && this.state.merchantConfig.comments) || {}
      );
    },
    merchantCommentTypeConfig() {
      return this.merchantCommentConfig[this.commentType] || {};
    },
    textCallToAction() {
      let text = t('call_to_action.' + this.commentType);
      if (text) return text;

      return t('call_to_action.product_comment');
    },
    profile() {
      return this.state.profile;
    },
    loginUrlParam() {
      return this.state.merchantConfig?.loginUrl || '';
    },
    loginUrl() {
      return getLocalizedString(this.loginUrlParam);
    }
  },
  methods: {
    t,
    md,
    openModal() {
      openCommentFormV2(this.commentType, this.targetId);
    },
    loadProductInfo() {
      this.myComments = [];
      if (!this.targetId) {
        return;
      }
      if (this.state.customerToken) {
        callApi(
          "GET",
          "/v1/client/my-comments?group_targets&target_id=" + this.targetId
        ).then(res => {
          if (res.status !== 200) {
            return;
          }
          res.json().then(data => {
            this.myComments = data.comments || [];
          });
        });
      }
    },
  },
  watch: {
    targetId() {
      this.loadProductInfo();
    }
  }
};
</script>
